// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__0Vv-Y","title":"style_title__ZGQ1B","bottom":"style_bottom__t4dBA","label":"style_label__l4hsU"};